module.exports = __webpack_public_path__ + "img/hanbao.8fd51c70.png";